module.exports = __webpack_public_path__ + "img/fast-payment-en.09732dc5.svg";